module.exports = __webpack_public_path__ + "img/affiliate.6bde8110.png";